import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import Card from "@particles/card/Card";
import { CardVariations, TemplateProps } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

/**
 * This is the template F of cards. It contains on block title, quote and 3 story cards.
 * https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=12726-24163&t=IJQKUG298X1zrCzY-4
 */
const TemplateF = ({
  className,
  header,
  cardProps,
}: TemplateProps): React.ReactElement => {
  const variations: CardVariations = {
    title: {
      color: cn("text-gray-850"),
      size: cn("text-4xl"),
      extraClass: cn("font-lct font-normal -tracking-2 leading-7 pb-8 mb-auto"),
    },
    content: {
      width: "",
      extraClass: "h-full",
    },
    byline: {
      extraClass: cn("items-end"),
      imageClassName: cn("order-2 [&>*]:border [&>*]:border-blue-100"),
      nameClassName: cn("order-1 pl-0 mr-auto [&_h4]:font-medium"),
    },
  };

  return (
    <div
      data-testid="card-template-component"
      data-template="template-f"
      className={className}
    >
      {header}

      <div className="grid auto-rows-fr grid-cols-1 gap-4 lg:grid-cols-3">
        {cardProps.map((props) => {
          return (
            <div
              key={props.link + props.title}
              className="flex flex-col gap-4 border border-blue-100 bg-gray-75 p-6"
            >
              <IconFactory
                type={IconTypeEnum.openQuotes}
                x={33}
                y={30}
                size={30}
                className="text-blue-175"
              />

              <Card
                {...props}
                variations={variations}
                className={cn("flex-grow")}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TemplateF;
